export const cityCoordinates = {
  SEATTLE: { lat: 47.60801, lng: -122.33516 },
};
